/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ClipDetailsUpdateRequest } from './clipDetailsUpdateRequest';

export interface UpdateClipRequest { 
    url?: string;
    mediaUrl?: string;
    publicationDate: Date;
    area?: string;
    pageNumber?: string;
    type?: UpdateClipRequest.TypeEnum;
    hasVideo?: boolean;
    important: boolean;
    mediumId: string;
    sif?: number;
    screenshotUrl?: string;
    visibilityIndex?: number;
    details: Array<ClipDetailsUpdateRequest>;
    tagIds?: Array<string>;
    authorIds?: Array<string>;
    transcribed?: boolean;
}
export namespace UpdateClipRequest {
    export type TypeEnum = 'NEUTRAL' | 'PROMOTIONAL' | 'ABUSIVE';
    export const TypeEnum = {
        NEUTRAL: 'NEUTRAL' as TypeEnum,
        PROMOTIONAL: 'PROMOTIONAL' as TypeEnum,
        ABUSIVE: 'ABUSIVE' as TypeEnum
    };
}